import { Edit, Trash, TickCircle, CloseCircle } from "iconsax-reactjs";
import Button from "../../commons/Button";
import { getImageUrl } from "../../../services/file/getImageUrl";
import {
  CONTENT_TYPE_LABELS,
  isTopBanner,
  type AnyBanner,
  type TopBanner,
  type ContentBanner,
} from "../../../services/webServices/banners/types";

type BannerItemProps = {
  banner: AnyBanner;
  onEdit: (banner: AnyBanner) => void;
  onDelete: (uuid: string) => void;
};

export default function BannerItem({ banner, onEdit, onDelete }: BannerItemProps) {
  const handleDelete = () => {
    const confirmed = window.confirm("آیا از حذف این بنر مطمئن هستید؟");
    if (!confirmed) return;
    onDelete(banner.uuid);
  };

  const isTop = isTopBanner(banner);
  const desktopImage = banner.desktop_image;
  const phoneImage = banner.phone_image;

  return (
    <div className="relative w-72 bg-white rounded-2xl shadow-md flex-shrink-0 overflow-hidden group">
      <div className="absolute top-3 right-3 z-20 flex gap-2 transition-opacity duration-300 group-hover:opacity-100 opacity-0 sm:group-hover:flex">
        <Button
          variant="neutral"
          style="solid"
          size="md"
          text=""
          loading={false}
          disabled={false}
          onClick={handleDelete}
          icon={Trash}
          customClassName="shadow-[0_0_10px_rgba(0,0,0,0.25)]"
        />
        <Button
          variant="neutral"
          style="solid"
          size="md"
          text=""
          loading={false}
          disabled={false}
          onClick={() => onEdit(banner)}
          icon={Edit}
          customClassName="shadow-[0_0_10px_rgba(0,0,0,0.25)]"
        />
      </div>

      <div className={`relative w-full overflow-hidden ${isTop ? "h-[50px] sm:h-[55px]" : "h-[138px]"}`}>

        {desktopImage && (
          <img
            loading="lazy"
            src={getImageUrl(desktopImage)}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
            style={{ clipPath: "polygon(0 0, 100% 100%, 0 100%)" }}
          />
        )}
        {phoneImage && (
          <img
            loading="lazy"
            src={getImageUrl(phoneImage)}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
            style={{ clipPath: "polygon(0 0, 100% 0, 100% 100%)" }}
          />
        )}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: "rgba(255,255,255,0.9)",
            clipPath:
              "polygon(0 0, 1.5% 0, 100% 98.5%, 100% 100%, 98.5% 100%, 0 1.5%)",
          }}
        />
      </div>

      <div className="h-20 bg-white flex items-start px-3 py-2">
        <div className="flex items-center justify-between w-full">
          <h3 className="relative pr-3 line-clamp-1 text-gray-600 font-medium text-base leading-7 before:absolute before:right-0 before:top-1/2 before:-translate-y-1/2 before:h-4 before:w-1 before:rounded before:bg-primaryVar-500">
            {banner.title}
          </h3>

          <div className="flex items-center gap-2">
            {isTop && (
              <span className="text-xs font-medium text-primaryVar-600 bg-primaryVar-50 bg-gray-100 px-2 py-0.5 rounded-full">
                {CONTENT_TYPE_LABELS[(banner as TopBanner).banner_type]}
              </span>
            )}
            {!isTop && (
              <span className="text-xs font-medium text-gray-600 bg-gray-100 px-2 py-0.5 rounded-full">
                #{((banner as ContentBanner).content_id ?? "").toString()}
              </span>
            )}

            <span
              className={
                banner.is_active
                  ? "inline-flex items-center gap-1 text-xs font-medium text-green-700 bg-green-100 px-2 py-0.5 rounded-full"
                  : "inline-flex items-center gap-1 text-xs font-medium text-red-700 bg-red-100 px-2 py-0.5 rounded-full"
              }
            >
              {banner.is_active ? (
                <TickCircle size={12} />
              ) : (
                <CloseCircle size={12} />
              )}
              {banner.is_active ? "فعال" : "غیرفعال"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
